export var permissionsTypes;
(function (permissionsTypes) {
    permissionsTypes["READ"] = "read";
    permissionsTypes["WRITE"] = "write";
    permissionsTypes["INFOFLASH"] = "infoflash";
    permissionsTypes["INBOX"] = "inbox";
    permissionsTypes["INBOX_MANAGER"] = "inbox_manager";
    permissionsTypes["EVENTS"] = "events";
    permissionsTypes["USERS"] = "users";
})(permissionsTypes || (permissionsTypes = {}));
export var UserRoles;
(function (UserRoles) {
    UserRoles["CLIENT_OWNER"] = "client-owner";
    UserRoles["CLIENT_MEMBER"] = "client-member";
    UserRoles["CLIENT_PERF_MSG_SPECIALIST"] = "client-perf-msg-specialist";
    UserRoles["PARTNER_OWNER"] = "partner-owner";
    UserRoles["PARTNER_MEMBER"] = "partner-member";
    UserRoles["PARTNER_PERF_MSG_SPECIALIST"] = "partner-perf-msg-specialist";
    UserRoles["ADMIN"] = "admin";
})(UserRoles || (UserRoles = {}));
export var UserPermissions;
(function (UserPermissions) {
    UserPermissions["START_CAMPAIGN"] = "campaigns:start_campaign";
    UserPermissions["SUBSCRIBE"] = "notifications:subscribe";
    UserPermissions["INVITE_USERS"] = "partner:invite_users";
    UserPermissions["ACCEPT_TOS"] = "tos:accept";
    UserPermissions["READ_TOS"] = "tos:read";
    UserPermissions["CHANGE_TEMPLATES"] = "waba:templates_change";
    UserPermissions["READ_BUNDLES"] = "bundles:read";
    UserPermissions["WRITE_BUNDLES"] = "bundles:write";
    UserPermissions["PARTNER_MANAGE"] = "partner:manage";
    UserPermissions["CLIENT_MANAGE"] = "client:manage";
    UserPermissions["SECURITY_MANAGE"] = "security:manage";
})(UserPermissions || (UserPermissions = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci50eXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZXIudHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMENBLE1BQU0sQ0FBTixJQUFZLGdCQVFYO0FBUkQsV0FBWSxnQkFBZ0I7SUFDMUIsaUNBQWEsQ0FBQTtJQUNiLG1DQUFlLENBQUE7SUFDZiwyQ0FBdUIsQ0FBQTtJQUN2QixtQ0FBZSxDQUFBO0lBQ2YsbURBQStCLENBQUE7SUFDL0IscUNBQWlCLENBQUE7SUFDakIsbUNBQWUsQ0FBQTtBQUNqQixDQUFDLEVBUlcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQVEzQjtBQXlIRCxNQUFNLENBQU4sSUFBWSxTQVFYO0FBUkQsV0FBWSxTQUFTO0lBQ25CLDBDQUE2QixDQUFBO0lBQzdCLDRDQUErQixDQUFBO0lBQy9CLHNFQUF5RCxDQUFBO0lBQ3pELDRDQUErQixDQUFBO0lBQy9CLDhDQUFpQyxDQUFBO0lBQ2pDLHdFQUEyRCxDQUFBO0lBQzNELDRCQUFlLENBQUE7QUFDakIsQ0FBQyxFQVJXLFNBQVMsS0FBVCxTQUFTLFFBUXBCO0FBRUQsTUFBTSxDQUFOLElBQVksZUFZWDtBQVpELFdBQVksZUFBZTtJQUN6Qiw4REFBMkMsQ0FBQTtJQUMzQyx3REFBcUMsQ0FBQTtJQUNyQyx3REFBcUMsQ0FBQTtJQUNyQyw0Q0FBeUIsQ0FBQTtJQUN6Qix3Q0FBcUIsQ0FBQTtJQUNyQiw2REFBMEMsQ0FBQTtJQUMxQyxnREFBNkIsQ0FBQTtJQUM3QixrREFBK0IsQ0FBQTtJQUMvQixvREFBaUMsQ0FBQTtJQUNqQyxrREFBK0IsQ0FBQTtJQUMvQixzREFBbUMsQ0FBQTtBQUNyQyxDQUFDLEVBWlcsZUFBZSxLQUFmLGVBQWUsUUFZMUIifQ==